/**
 * Spec 038: how a company tool and its calls read. Plain functions: the tests run this module as
 * it is.
 */
import type { CompanyToolOut, ToolCallOut, ToolCallState, ToolFileOut } from "@/api/units";

export const CALL_STATE: Record<ToolCallState, string> = {
  queued: "в очереди",
  in_progress: "генерируется",
  completed: "готово",
  failed: "не вышло",
  nsfw: "отклонено модерацией",
  canceled: "отменено",
  error: "ошибка",
};

export type Tone = "done" | "waiting" | "needs" | "blocked";

export function callTone(state: ToolCallState): Tone {
  if (state === "completed") return "done";
  if (state === "queued" || state === "in_progress") return "waiting";
  if (state === "canceled") return "needs";
  return "blocked";
}

/** «ключ привязан · за месяц 12, готово 10». */
export function toolLine(t: Pick<CompanyToolOut, "has_key" | "month_calls" | "month_done" | "archived_at">): string {
  const parts = [t.archived_at ? "в архиве" : t.has_key ? "ключ привязан" : "ключ не привязан — не работает"];
  if (t.month_calls) parts.push(`за месяц ${t.month_calls}, готово ${t.month_done}`);
  return parts.join(" · ");
}

const KIND: Record<string, string> = { image: "Картинка", video: "Видео", audio: "Звук" };

export function fileLabel(f: Pick<ToolFileOut, "n" | "kind" | "bytes">): string {
  const size = f.bytes ? ` · ${(f.bytes / 1024 / 1024).toFixed(f.bytes > 10 * 1024 * 1024 ? 0 : 1)} МБ` : "";
  return `${KIND[f.kind] ?? "Файл"} ${f.n + 1}${size}`;
}

/** What was asked, in one line: the prompt if there is one, else the fields. */
export function askLine(c: Pick<ToolCallOut, "input">): string {
  const prompt = c.input?.prompt;
  if (typeof prompt === "string" && prompt.trim()) return prompt.trim().slice(0, 200);
  return Object.keys(c.input ?? {}).join(", ") || "—";
}

const KEY = /^[a-z0-9][a-z0-9_-]{0,39}$/;

/** The key a card grants a tool by: latin, «higgsfield». */
export function keyProblem(key: string): string {
  return KEY.test(key.trim().toLowerCase()) ? "" : "Латиница, цифры, «-» и «_»: например higgsfield";
}
